import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import RouterConfig from '../router'
import { checkUserAuthentication } from '../store/user/actions'
import { ToastContainer } from 'react-toastify'
import moment from 'moment'

class Setup extends Component {

	componentDidMount() {
		moment.locale('es')
		this.props.checkUserAuthentication()
	}

	render() {

		if (this.props.authenticated == null) return null

		return (
			<div>
				<ToastContainer />
				<RouterConfig />
			</div>

		)
	}
}

function mapStateToProps(state) {
	return {
		authenticated: state.user.authenticated
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		checkUserAuthentication
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Setup)



// WEBPACK FOOTER //
// ./src/app/Setup.js